import React, { Component } from 'react'
import config from 'config'
import { getUserInfo } from 'common/user'
import Close from '../Close'
import qs from 'querystring'
import styles from './index.css'

class Correction extends Component {
  constructor(props){
    super(props)
    this.state = {
      errorInfo: '',
      isSubmit: false,
      checkList: [
        {text: '阅读文章有误', checked: false},
        {text: '题干有误', checked: false },
        {text: '选项有误', checked: false },
        {text: '答案有误', checked: false },
        {text: '文字解析有误', checked: false },
        {text: '听力原文有误', checked: false },
        {text: '阅读译文有误', checked: false },
        {text: '页面显示有误', checked: false }
      ]
    }

    this.errorType = []
    this.detail = ''
  }

  handleChangeErrorType(checkedIdx) {
    const { checkList } = this.state;
    this.setState({
      checkList: checkList.map((item, idx) => {
        return checkedIdx === idx ? { ...item, checked: !item.checked } : item
      })
    })
  }

  handleDetail(e) {
    this.detail = e.target.value
  }

  submitCorrection() {
    const { questionId, questionName, onClose } = this.props
    const { checkList } = this.state
    const errorType = checkList.filter((item) => {
      return item.checked
    }).map((item) => {return item.text}).join()

    fetch(`${config.api.ti}/correction`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: qs.stringify({
        questionName: questionName || '',
        token: getUserInfo() ? getUserInfo().token : null,
        questionId: questionId,
        errorType: errorType || '',
        detail: this.detail || ''
      })
    })
    .then(res => res.json())
    .then(json => {
      if(json.code !== 0) {
        this.setState({
          errorInfo: json.msg
        })
      } else {
        this.setState({
          errorInfo: '我们已收到反馈'
        }, () => {
          setTimeout(() => {
            onClose()
          }, 1000)
        })
      }
    })
  }

  renderCheckbox() {
    return this.state.checkList.map((item, idx) => {
      return (
        <label key={idx} htmlFor={`correct${idx}`}>
          <input
            id={`correct${idx}`}
            type='checkbox'
            value={ item.text }
            checked={ item.checked }
            onChange={ () => this.handleChangeErrorType(idx) }
          />
        { item.text }
        </label>
      )
    })
  }

  renderBtn() {
    const { checkList } = this.state;
    const isDisabled = checkList.every((item) => {
      return !item.checked;
    });

    return  (
      <button
        className={ isDisabled ? styles.notSubmit : styles.submitBtn }
        onClick={ () => !isDisabled && this.submitCorrection() }
      >
        提交反馈
      </button>
    );
  }

  render() {
    return (
      <div className={ styles.wrap }>
        <div className={ styles.pop }>
          <Close onChange={this.props.onClose} />
          <h1>我要纠错</h1>
            { this.renderCheckbox() }
            <textarea
              className={ styles.textarea }
              placeholder='将问题描述清楚，处理更及时哦~'
              onInput={ e => this.handleDetail(e) }
            />
            <div className={styles.submitContent}>
              {this.renderBtn()}
            </div>
            <p className={styles.errorTips}>{ this.state.errorInfo }</p>
        </div>
      </div>
    )
  }
}

export default Correction



/** WEBPACK FOOTER **
 ** ./src/components/Common/Correction/index.js
 **/